var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNigeriaIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.832031 0.878906H12.9993V9.5698H0.832031V0.878906Z",
    fill: "url(#paint0_linear_5545_79731)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.62695 0.878906H13.0003V9.5698H6.62695V0.878906Z",
    fill: "url(#paint1_linear_5545_79731)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.832031 0.878906H4.88778V9.5698H0.832031V0.878906Z",
    fill: "url(#paint2_linear_5545_79731)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88867 0.878906H8.94442V9.5698H4.88867V0.878906Z",
    fill: "url(#paint3_linear_5545_79731)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5545_79731",
    x1: 128.588,
    y1: 0.878906,
    x2: 128.588,
    y2: 131.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5545_79731",
    x1: 73.5468,
    y1: 0.878906,
    x2: 73.5468,
    y2: 131.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#189B62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#118653"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5545_79731",
    x1: 43.4174,
    y1: 0.878906,
    x2: 43.4174,
    y2: 131.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#189B62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#118653"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5545_79731",
    x1: 47.474,
    y1: 0.878906,
    x2: 47.474,
    y2: 131.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigeriaIc);
export default __webpack_public_path__ + "static/media/nigeria-ic.634a1b4dcae1943e77490d06bea5494e.svg";
export { ForwardRef as ReactComponent };